import { render, staticRenderFns } from "./AstaComeFunziona.vue?vue&type=template&id=a225d4aa&scoped=true&"
import script from "./AstaComeFunziona.vue?vue&type=script&lang=js&"
export * from "./AstaComeFunziona.vue?vue&type=script&lang=js&"
import style0 from "./AstaComeFunziona.vue?vue&type=style&index=0&id=a225d4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a225d4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a225d4aa')) {
      api.createRecord('a225d4aa', component.options)
    } else {
      api.reload('a225d4aa', component.options)
    }
    module.hot.accept("./AstaComeFunziona.vue?vue&type=template&id=a225d4aa&scoped=true&", function () {
      api.rerender('a225d4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaComeFunziona.vue"
export default component.exports